type LegalBlock =
  | { type: "paragraph"; text: string }
  | { type: "bullets"; items: string[] };

type LegalSection = {
  title: string;
  blocks: LegalBlock[];
};

const sections: LegalSection[] = [
  {
    title: "1. Geltungsbereich",
    blocks: [
      {
        type: "paragraph",
        text: "(1) Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für alle Verträge zwischen dem Anbieter (nachfolgend „Anbieter“) und seinen Kunden (nachfolgend „Kunde“) über die Erstellung und den Betrieb von Websites im Rahmen eines Website-as-a-Service (WaaS)-Modells.",
      },
      {
        type: "paragraph",
        text: "(2) Das Angebot richtet sich ausschließlich an Unternehmer im Sinne von § 14 BGB sowie gleichgestellte Organisationen (z. B. Freiberufler, Vereine, Körperschaften des öffentlichen Rechts). Verträge mit Verbrauchern im Sinne von § 13 BGB werden nicht geschlossen.",
      },
      {
        type: "paragraph",
        text: "(3) Entgegenstehende oder abweichende Bedingungen des Kunden werden nicht anerkannt, es sei denn, ihrer Geltung wird ausdrücklich schriftlich zugestimmt.",
      },
    ],
  },
  {
    title: "2. Vertragsgegenstand",
    blocks: [
      {
        type: "paragraph",
        text: "(1) Der Anbieter bietet die Erstellung, Bereitstellung und den Betrieb individueller Websites unter Einsatz von KI-Technologien an.",
      },
      {
        type: "paragraph",
        text: "(2) Der Leistungsumfang umfasst insbesondere:",
      },
      {
        type: "bullets",
        items: [
          "Erstellung einer individuellen Website",
          "Hosting der Website",
          "Bereitstellung einer Domain (optional)",
          "Betrieb und Wartung",
          "regelmäßige Backups",
          "bis zu 2 Stunden Anpassungen pro Monat (nicht übertragbar)",
        ],
      },
      {
        type: "paragraph",
        text: "(3) Der Anbieter erstellt zunächst einen unverbindlichen Entwurf der Website. Ein Vertrag kommt erst zustande, wenn der Kunde das kostenpflichtige Paket über die angebotenen Zahlungswege bucht und die erforderlichen Vertrags- und Rechtshinweise bestätigt.",
      },
      {
        type: "paragraph",
        text: "(4) Nach Vertragsschluss erfolgt die Finalisierung und Veröffentlichung der Website innerhalb von ca. 2 Wochen, vorausgesetzt der Kunde stellt alle erforderlichen Inhalte und Informationen rechtzeitig zur Verfügung.",
      },
    ],
  },
  {
    title: "3. Vertragsschluss",
    blocks: [
      {
        type: "paragraph",
        text: "(1) Die Präsentation der Leistungen stellt kein rechtlich bindendes Angebot dar.",
      },
      {
        type: "paragraph",
        text: "(2) Der Vertrag kommt zustande durch:",
      },
      {
        type: "bullets",
        items: [
          "Auswahl des Pakets durch den Kunden",
          "Abschluss des Zahlungsvorgangs über Stripe (inkl. PayPal/Kreditkarte)",
        ],
      },
      {
        type: "paragraph",
        text: "(3) Mit erfolgreicher Zahlung beginnt die Vertragslaufzeit.",
      },
      {
        type: "paragraph",
        text: "(4) Ein gesetzliches Widerrufsrecht für Verbraucher findet keine Anwendung, da der Vertrag ausschließlich mit Unternehmern geschlossen wird.",
      },
    ],
  },
  {
    title: "4. Preise und Zahlungsbedingungen",
    blocks: [
      {
        type: "paragraph",
        text: "(1) Die Preise setzen sich wie folgt zusammen:",
      },
      {
        type: "bullets",
        items: [
          "Einmalige Einrichtungsgebühr: ab 500 €",
          "Monatliche Gebühr: ab 99 €",
        ],
      },
      {
        type: "paragraph",
        text: "(2) Alle Preisangaben verstehen sich netto zuzüglich gesetzlicher Umsatzsteuer. Der jeweils maßgebliche Endbetrag wird vor Abschluss des Bestellvorgangs ausgewiesen.",
      },
      {
        type: "paragraph",
        text: "(3) Die Zahlung erfolgt über den Zahlungsdienstleister Stripe.",
      },
      {
        type: "paragraph",
        text: "(4) Die monatlichen Gebühren sind im Voraus zu entrichten.",
      },
      {
        type: "paragraph",
        text: "(5) Der Anbieter ist berechtigt, Preise mit angemessener Frist anzupassen. Änderungen werden dem Kunden per E-Mail mitgeteilt.",
      },
    ],
  },
  {
    title: "5. Vertragslaufzeit und Kündigung",
    blocks: [
      {
        type: "paragraph",
        text: "(1) Die Mindestvertragslaufzeit beträgt 12 Monate ab Vertragsschluss.",
      },
      {
        type: "paragraph",
        text: "(2) Nach Ablauf der Mindestlaufzeit verlängert sich der Vertrag automatisch auf unbestimmte Zeit und kann monatlich gekündigt werden.",
      },
      {
        type: "paragraph",
        text: "(3) Die Kündigung ist derzeit in Textform, insbesondere per E-Mail an kontakt@mutzur.de, zu erklären. Eine gesonderte Kündigungsfunktion im Dashboard besteht aktuell nicht.",
      },
      {
        type: "paragraph",
        text: "(4) Nach Vertragsende endet der Betrieb der Website durch den Anbieter mit Ablauf der jeweiligen Vertragslaufzeit, sofern keine Anschlussvereinbarung getroffen wird.",
      },
      {
        type: "paragraph",
        text: "(5) Eine automatische Download-, Export- oder Handover-Funktion über das Dashboard besteht derzeit nicht. Soweit eine Übergabe von Dateien, Zugangsdaten oder sonstigen Projektunterlagen vereinbart ist, erfolgt diese nach gesonderter Abstimmung.",
      },
      {
        type: "paragraph",
        text: "(6) Gesetzliche Aufbewahrungspflichten bleiben unberührt. Im Übrigen werden Daten nach Vertragsende und Abschluss der Abwicklung im Rahmen der gesetzlichen Vorgaben gelöscht.",
      },
    ],
  },
  {
    title: "6. Mitwirkungspflichten des Kunden",
    blocks: [
      {
        type: "paragraph",
        text: "(1) Der Kunde ist verpflichtet, alle für die Erstellung der Website erforderlichen Inhalte, Daten und Informationen rechtzeitig bereitzustellen.",
      },
      {
        type: "paragraph",
        text: "(2) Verzögerungen aufgrund verspäteter Mitwirkung des Kunden gehen nicht zulasten des Anbieters.",
      },
      {
        type: "paragraph",
        text: "(3) Der Kunde ist verpflichtet:",
      },
      {
        type: "bullets",
        items: [
          "Zugangsdaten sicher aufzubewahren",
          "missbräuchliche Nutzung zu verhindern",
          "den Anbieter unverzüglich über Sicherheitsvorfälle zu informieren",
        ],
      },
    ],
  },
  {
    title: "7. Nutzungsrechte und Eigentum",
    blocks: [
      {
        type: "paragraph",
        text: "(1) Sämtliche Rechte an Konzepten, Designs, Templates, Quelltexten und sonstigen vom Anbieter erstellten Arbeitsergebnissen verbleiben beim Anbieter, soweit nicht ausdrücklich etwas anderes vereinbart ist.",
      },
      {
        type: "paragraph",
        text: "(2) Der Kunde erhält für die Dauer des Vertrags ein einfaches, nicht ausschließliches Nutzungsrecht an der bereitgestellten Website für die vertraglich vorgesehenen Zwecke.",
      },
      {
        type: "paragraph",
        text: "(3) Eine Übertragung weitergehender Rechte oder die Herausgabe von Quellcode, Deployments, Zugangsdaten oder sonstigen Projektartefakten setzt eine gesonderte Vereinbarung und die vollständige Vergütung etwaiger hierfür geschuldeter Leistungen voraus.",
      },
    ],
  },
  {
    title: "8. Inhalte und Verantwortung",
    blocks: [
      {
        type: "paragraph",
        text: "(1) Der Kunde ist allein verantwortlich für sämtliche bereitgestellten Inhalte.",
      },
      {
        type: "paragraph",
        text: "(2) Der Kunde versichert, dass seine Inhalte keine Rechte Dritter verletzen und nicht gegen geltendes Recht verstoßen.",
      },
      {
        type: "paragraph",
        text: "(3) Insbesondere sind folgende Inhalte untersagt:",
      },
      {
        type: "bullets",
        items: [
          "illegale Inhalte jeglicher Art",
          "betrügerische oder irreführende Inhalte",
          "Spam oder Massenkommunikation",
          "pornografische oder jugendgefährdende Inhalte",
          "extremistische Inhalte",
          "urheberrechtsverletzende Inhalte",
          "Inhalte, die gegen Wettbewerbsrecht verstoßen",
        ],
      },
      {
        type: "paragraph",
        text: "(4) Der Anbieter ist berechtigt, rechtswidrige Inhalte zu entfernen oder den Zugang zu sperren.",
      },
    ],
  },
  {
    title: "9. Leistungsänderungen und Anpassungen",
    blocks: [
      {
        type: "paragraph",
        text: "(1) Anpassungen im Umfang von bis zu 2 Stunden pro Monat sind im Preis enthalten.",
      },
      {
        type: "paragraph",
        text: "(2) Nicht genutzte Stunden verfallen und sind nicht übertragbar.",
      },
      {
        type: "paragraph",
        text: "(3) Weitergehende Leistungen werden gesondert berechnet.",
      },
    ],
  },
  {
    title: "10. Verfügbarkeit",
    blocks: [
      {
        type: "paragraph",
        text: "(1) Der Anbieter gewährleistet eine durchschnittliche Verfügbarkeit der Dienste von 95 % im Jahresmittel.",
      },
      {
        type: "paragraph",
        text: "(2) Hiervon ausgenommen sind:",
      },
      {
        type: "bullets",
        items: [
          "Wartungsarbeiten",
          "höhere Gewalt",
          "Ausfälle durch Drittanbieter",
        ],
      },
    ],
  },
  {
    title: "11. Haftung",
    blocks: [
      {
        type: "paragraph",
        text: "(1) Der Anbieter haftet unbeschränkt bei:",
      },
      {
        type: "bullets",
        items: [
          "Vorsatz",
          "grober Fahrlässigkeit",
          "Verletzung von Leben, Körper oder Gesundheit",
        ],
      },
      {
        type: "paragraph",
        text: "(2) Bei einfacher Fahrlässigkeit haftet der Anbieter nur bei Verletzung wesentlicher Vertragspflichten (Kardinalpflichten) und begrenzt auf den vorhersehbaren Schaden.",
      },
      {
        type: "paragraph",
        text: "(3) Eine Haftung für mittelbare Schäden, insbesondere entgangenen Gewinn, ist ausgeschlossen.",
      },
      {
        type: "paragraph",
        text: "(4) Der Anbieter haftet nicht für:",
      },
      {
        type: "bullets",
        items: [
          "Ausfälle von Drittanbietern (z. B. Hosting, Zahlungsanbieter)",
          "Datenverluste, sofern diese nicht vorsätzlich oder grob fahrlässig verursacht wurden",
        ],
      },
    ],
  },
  {
    title: "12. Drittanbieter",
    blocks: [
      {
        type: "paragraph",
        text: "(1) Der Anbieter nutzt zur Leistungserbringung externe Dienstleister, insbesondere:",
      },
      {
        type: "bullets",
        items: [
          "Stripe (Zahlungsabwicklung)",
          "Hetzner (Hosting)",
          "IONOS (Domain- und Infrastrukturleistungen)",
        ],
      },
      {
        type: "paragraph",
        text: "(2) Für Leistungen dieser Drittanbieter übernimmt der Anbieter keine Haftung.",
      },
    ],
  },
  {
    title: "13. Datenschutz",
    blocks: [
      {
        type: "paragraph",
        text: "(1) Der Anbieter verarbeitet personenbezogene Daten gemäß den geltenden Datenschutzbestimmungen.",
      },
      {
        type: "paragraph",
        text: "(2) Weitere Informationen sind in der separaten Datenschutzerklärung geregelt.",
      },
    ],
  },
  {
    title: "14. Änderungen der AGB",
    blocks: [
      {
        type: "paragraph",
        text: "(1) Der Anbieter ist berechtigt, diese AGB mit Wirkung für die Zukunft zu ändern.",
      },
      {
        type: "paragraph",
        text: "(2) Änderungen werden dem Kunden per E-Mail mitgeteilt.",
      },
      {
        type: "paragraph",
        text: "(3) Widerspricht der Kunde nicht innerhalb von 14 Tagen, gelten die Änderungen als angenommen.",
      },
    ],
  },
  {
    title: "15. Schlussbestimmungen",
    blocks: [
      {
        type: "paragraph",
        text: "(1) Es gilt das Recht der Bundesrepublik Deutschland.",
      },
      {
        type: "paragraph",
        text: "(2) Ist der Kunde Kaufmann, juristische Person des öffentlichen Rechts oder öffentlich-rechtliches Sondervermögen, ist Gerichtsstand Dresden. Entsprechendes gilt, soweit der Kunde keinen allgemeinen Gerichtsstand in Deutschland hat.",
      },
      {
        type: "paragraph",
        text: "(3) Sollten einzelne Bestimmungen unwirksam sein, bleibt die Wirksamkeit der übrigen Bestimmungen unberührt.",
      },
    ],
  },
];

export function Agb() {
  return (
    <div className="bg-stone-50 pt-20 text-gray-950">
      <section className="border-b border-stone-200 bg-white">
        <div className="mx-auto max-w-4xl px-4 py-16 sm:px-6 lg:px-8 lg:py-20">
          <p className="text-sm font-medium uppercase tracking-[0.2em] text-gray-500">Rechtliches</p>
          <h1 className="mt-4 text-4xl leading-tight lg:text-5xl">
            Allgemeine Geschäftsbedingungen (AGB)
          </h1>
        </div>
      </section>

      <section className="py-12 lg:py-16">
        <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
          <div className="rounded-3xl border border-stone-200 bg-white p-6 shadow-sm sm:p-8 lg:p-10">
            <div className="space-y-10">
              {sections.map((section) => (
                <section key={section.title} className="space-y-4">
                  <h2 className="text-2xl font-semibold tracking-tight">{section.title}</h2>
                  {section.blocks.map((block) =>
                    block.type === "paragraph" ? (
                      <p key={block.text} className="text-base leading-relaxed text-gray-700">
                        {block.text}
                      </p>
                    ) : (
                      <ul
                        key={block.items.join("|")}
                        className="space-y-2 pl-5 text-base leading-relaxed text-gray-700"
                      >
                        {block.items.map((bullet) => (
                          <li key={bullet} className="list-disc">
                            {bullet}
                          </li>
                        ))}
                      </ul>
                    ),
                  )}
                </section>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
